import { ContentDiscrepanciesDiagnostic } from "./ContentDiscrepanciesDiagnostic";
import { DiagnosticOption } from "../DeveloperDiagnosticsPage";
import React from "react";

export const contentDiscrepanciesDiagnosticOption: DiagnosticOption = {
  label: "Find Content Discrepancies",
  iconProvider: () => require("@material-ui/icons").DiscFull,
  render: ContentDiscrepanciesDiagnostic
};
